// app-src-react/hooks/useLogo.js
import { useTheme } from '@mui/material/styles';

const useLogo = () => {
  const theme = useTheme();

  const logoUrl = theme.palette.mode === 'dark'
    ? 'https://storage.googleapis.com/epl-public-assets/epl_50x50_w.png'
    : 'https://storage.googleapis.com/epl-public-assets/epl_50x50_b.png';

  return logoUrl;
};

export default useLogo;
